var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad20-tb flex justify-around" },
    _vm._l(_vm.list, function(item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass:
            "flex flex-column justify-center items-center radius5 pointer bg-f2 item"
        },
        [
          _c("div", { staticClass: "fb f28 gray3" }, [
            _vm._v(_vm._s(item.name))
          ]),
          _c("div", { staticClass: "f16 mar10-t gray6" }, [
            _vm._v(_vm._s(item.des))
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }